import { FC } from 'react'
import { Text } from '@blueprintjs/core'
import { Link, usePage } from '@inertiajs/react'
import { Button } from 'client/components/Button/Button'
import { ResponsiveBlock } from 'client/components/ResponsiveBlock/ResponsiveBlock'
import Logo from 'images/logo.svg?react'
import { useTranslation } from 'react-i18next'
import { ClientLocaleNS } from 'lib/constants/locales'
import { ClientPageProps } from 'types'

type TProps = {}

const Header: FC<TProps> = () => {
  const {
    props: { user },
  } = usePage<ClientPageProps>()
  const { t } = useTranslation(ClientLocaleNS.Common)
  return (
    <header className="relative flex w-full justify-center">
      <ResponsiveBlock className="flex w-full" contentClassName="gap-8 justify-between items-center">
        <Link
          href="/"
          className="flex items-center gap-4 text-palette-white hover:text-palette-white hover:no-underline"
        >
          <Logo className="h-9" />
          <Text tagName="span" className="font-title---50px uppercase">
            Digimarket
          </Text>
        </Link>
        <div className="flex items-center gap-4">
          {/* <Button className="font-body---20px h-12 px-8">{t('header.button')}</Button> */}
          {!!user ? (
            <Link href="/profile">
              <Button className="font-body---20px h-12 px-8">{t('header.profile')}</Button>
            </Link>
          ) : (
            <Link href="/sign_in">
              <Button className="font-body---20px h-12 px-8">{t('header.sign_in')}</Button>
            </Link>
          )}
        </div>
        {/* <GradientBorder className="h-20 flex-1 px-4">
          <div className="flex w-full items-center gap-8">
            <InputGroup
              className="border-none"
              inputClassName="font-body---14px uppercase outline-none bg-transparent focus:shadow-none"
              placeholder={t('header.search.placeholder')}
              value=""
              onValueChange={() => {}}
              large
              fill
            />
            <Cross className="flex-none" />
            <Button>{t('header.search.button')}</Button>
          </div>
        </GradientBorder> */}
      </ResponsiveBlock>
    </header>
  )
}

export { Header }
